import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import { Typography } from 'src/components/coreUI';
import { Radio } from 'src/components/custom';

const TermAndCondition = (props: {
  handlePayment: () => Promise<any>;
  handleBack: () => void;
  loading: boolean;
}) => {
  const [checked, setChecked] = useState<boolean>(false);

  return (
    <React.Fragment>
      <Typography.Title className="mt-0">TERMS AND CONDITIONS</Typography.Title>

      <div
        className="mb-24 bg-gray-1 p-20"
        style={{ maxHeight: 350, overflowY: 'scroll' }}
      >
        <div className="mb-24">
          Insignia Ventures Academy <span className="fw-bold">(“IVA”)</span>{' '}
          formally welcomes you to the Venture Capital Launchpad Program{' '}
          <span className="fw-bold">(“VC Launchpad”)</span>. <br /> <br /> By
          indicating your acceptance to the terms and conditions, you agree to
          the terms outlined in this document:
        </div>
        <div>
          <span className="fw-bold">Course Access</span>: The VC Launchpad
          course is an online course that can be accessed for either a period of
          3 months or 6 months, depending on the option chosen at the time of
          purchase. <br /> <br />
          <span className="fw-bold">Course Content</span>: The course content,
          including all videos, activities, and assessments, are the exclusive
          property of Insignia Venture Academy (IVA) and are protected by
          copyright laws. The course content may not be reproduced, distributed,
          or used for any other purpose without the written consent of IVA.{' '}
          <br /> <br />
          <span className="fw-bold">Pricing</span>: The course is offered at two
          pricing options: SG$399 for 3 months’ access or SG$599 for 6 months’
          access. Payment is due at the time of enrollment and is
          non-refundable. However, in the event of a technical issue preventing
          access to the course content for more than 5 business days, IVA may,
          at its sole and absolute discretion, offer a refund or credit. <br />{' '}
          <br />
          <span className="fw-bold">Enrollment</span>: Enrollment in the course
          is subject to acceptance of these terms and conditions. By enrolling
          in the course, you agree to be bound by these terms and conditions.
          The terms of this agreement are intended to be legally binding, or
          unless otherwise notified to you by Insignia Ventures Academy. <br />{' '}
          <br />
          <span className="fw-bold">Access Termination</span>: IVA reserves the
          right to terminate access to the course at any time and for any
          reason, including but not limited to violation of these terms and
          conditions. <br /> <br />
          <span className="fw-bold">Certification</span>: Upon successful
          completion of the course, you will receive a certificate of
          completion. However, the certificate does not
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          guarantee admission to IVA's 12-week VC accelerator programme or any
          other career opportunities in the IVA network. <br /> <br />
        </div>
      </div>

      <div className="flex-col justify-center align-center space-y-18">
        <Radio
          checked={checked}
          wrapperClassName="justify-center"
          label={'I have read and agree to accept the Terms and Conditions'}
          onClick={(e) => {
            setChecked(!checked);
          }}
        />

        <div className="d-flex justify-center gap-16">
          <Button basic color="purple" onClick={props.handleBack}>
            Cancel
          </Button>
          <Button
            primary
            loading={props.loading}
            color="purple"
            disabled={!checked}
            onClick={async () => {
              await props.handlePayment();
            }}
          >
            Process Payment
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TermAndCondition;
